import { render, staticRenderFns } from "./SendMessageTemplateEdit.vue?vue&type=template&id=21244444&scoped=true&lang=pug"
import script from "./SendMessageTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateEdit.vue?vue&type=style&index=0&id=21244444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21244444",
  null
  
)

export default component.exports